import shopMemberBind from '@/page/shopMember/pages/bind.vue'

// 商家会员绑定（解绑）页面
const shopMemberBindPage = {
  path: '/shopMember/bind',
  name: 'shopMemberBind',
  component: shopMemberBind,
}

export default [shopMemberBindPage]
